@if (news$(); as page) {
  <article class="overflow-hidden">
    <!--<app-header [title]="page.title" [image]="page.image" [intro]="page.intro"></app-header>-->

    <header class="pt-topbar bg-accent">
      <div class="container">
        <div class="section-inset-t pb-3 pb-md-4 text-max-width-sm mx-auto">
          <span class="fs-body-md fw-normal d-inline-block w-100 mb-2">
            <a class="text-decoration-none" [routerLink]="['/nieuws']">Nieuws</a>
            | {{ page.publicationDate | newsDate }}
          </span>

          @if (page.subtitle) {
            <strong class="subtitle mb-3 mt-4">{{ page.subtitle }}</strong>
          }
          <h1 class="h2">
            <span>{{ page.title }}</span>
          </h1>

          @if (page.intro) {
            <p class="lead mt-3 mt-sm-4">{{ page.intro }}</p>
          }
        </div>
      </div>
    </header>

    @if (page.image?.url; as imageUrl) {
      <div class="page-image text-center">
        <figure class="container d-inline-block w-auto">
          <img
            [ngSrc]="imageUrl"
            [width]="1200"
            [height]="1200"
            [alt]="page.image?.alt || page.image?.caption"
            ngSrcset="550w, 800w, 1600w"
            [loaderParams]="{
              width: 1200,
              height: 1200,
              anchor: page.image?.anchor || 'middlecenter',
              scale: 'both',
            }"
            [attr.data-object-position]="page.image?.anchor || 'middlecenter'"
            [priority]="true"
            [sizes]="'100w'"
            [loaderParams]="{ scale: 'both', mode: 'max', width: 1200, height: 1200 }"
          />

          @if (page.image!.caption) {
            <figcaption class="caption mt-2">{{ page.image!.caption }}</figcaption>
          }
        </figure>
      </div>
    }
    @if (page.text) {
      <section class="container pt-3 pt-md-4 section-inset-b">
        <ngx-dynamic-hooks
          class="markdown-content d-block text-max-width-sm mx-auto"
          [options]="{ sanitize: false, updateOnPushOnly: true }"
          [content]="page.text | resizeHtmlImages | stripEmbed: cookiePreferences() || undefined"
          fstrDynamicContent
        ></ngx-dynamic-hooks>

        @if (page.lastEditDate) {
          <span class="text-body-tertiary d-block text-max-width-sm mx-auto border-top pt-2 mt-4">
            {{ 'laatst-bewerkt-op-prefix' | fromDictionary }} {{ page.lastEditDate | newsDate }}
          </span>
        }

        <div
          class="d-flex gap-3 justify-content-between flex-wrap text-max-width-sm mx-auto bg-secondary-subtle rounded-4 mt-4 mt-md-5 py-2 px-3"
        >
          <button class="button button-link button--secondary" (click)="back()">
            <fstr-icon anchor="line-icon-arrow-left"></fstr-icon>
            <span>Terug</span>
          </button>
          <a class="button button-link button--secondary" [routerLink]="['/nieuws']">
            <fstr-icon anchor="line-icon-grid"></fstr-icon>
            <span>Alle nieuws</span>
          </a>
        </div>
      </section>
    }
  </article>
}
